var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.998047 1.5C0.998047 1.42969 1.01172 1.36523 1.03906 1.30664C1.06641 1.24414 1.10156 1.19141 1.14453 1.14844C1.19141 1.10156 1.24414 1.06445 1.30273 1.03711C1.36523 1.00977 1.43164 0.996094 1.50195 0.996094C1.57617 0.996094 1.64062 1.00977 1.69531 1.03711C1.75 1.06055 1.80273 1.09766 1.85352 1.14844L5 4.29492L8.14648 1.14844C8.24805 1.04688 8.36523 0.996094 8.49805 0.996094C8.56836 0.996094 8.63281 1.00977 8.69141 1.03711C8.75391 1.06445 8.80664 1.10156 8.84961 1.14844C8.89648 1.19141 8.93359 1.24414 8.96094 1.30664C8.98828 1.36523 9.00195 1.42969 9.00195 1.5C9.00195 1.63672 8.95312 1.75391 8.85547 1.85156L5.35156 5.35547C5.25391 5.45312 5.13672 5.50195 5 5.50195C4.86328 5.50195 4.74609 5.45312 4.64844 5.35547L1.14453 1.85156C1.04688 1.75391 0.998047 1.63672 0.998047 1.5Z",
    fill: "#706E6E",
    fillOpacity: 0.786
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownIcon);
export default __webpack_public_path__ + "static/media/arrowDownIcon.584bfad7f514fbfd5788e2ef4db3f145.svg";
export { ForwardRef as ReactComponent };